import React from 'react'

const PercentageFormat = ({ value, decimals = 0 }) => (
    <span>{toPercentageWholeIntegerNoRounding(value, decimals).toLocaleString('en')} %</span>
)

const toPercentageWholeIntegerNoRounding = (value, fixed) => {
    var num = Number(value * 100)
    var re = new RegExp('^-?\\d+(?:.\\d{0,' + (fixed || -1) + '})?')
    return num.toString().match(re)[0]
}

export default PercentageFormat
